const unknownfacts = [
  {
    title: <span classname="highlight">కృష్ణుని గురించి అతి తక్కువ మందికి తెలిసిన ఆసక్తికరమైన విషయాలు :</span>,
  },
  {
    title: "శ్రీకృష్ణుడు 5,252 సంవత్సరాల క్రితం జన్మించాడు.",
  },
  {
    title: "శ్రీకృష్ణుని పుట్టిన తేది  21.07.3228",
  },
  {
    title: "మాసం : శ్రావణం",
  },
  {
    title: "తిథి: అష్టమి",
  },
  {
    title: "నక్షత్రం : రోహిణి",
  },
  {
    title: "వారం : బుధవారం",
  },
  {
    title: "శ్రీకృష్ణుని జీవిత కాలం : 125 సంవత్సరాల 8 నెలల 7 రోజులు",
  },
  {
    title: "శ్రీకృష్ణుని మరణం:  18.02.3102",
  },
  {
    title: "శ్రీకృష్ణుని 89వ యేట కురుక్షేత్రం జరిగినది",
  },
  {
    title: "శ్రీకృష్ణుడు కురుక్షేత్రం జరిగిన 36 సంవత్సరాల తరువాత మరణించెను",
  },
  {
    title: "కురుక్షేత్రం . 08.12.3139 న మృగశిర శుక్ల ఏకాదశినాడు ప్రారంభమై 25.12.3139 న ముగిసినది.  21.12.3139 న 3 గం. నుంచి 5 గం.ల వరకు సంభవించిన సూర్య గ్రహణం జయద్రదుని మరణానికి కారణమయ్యెను.",
  },
  {
    title: "భీష్ముడు . 02.02.3138 న ఉత్తరాయణంలో మొదటి ఏకాదశినాడు ప్రాణము విడిచెను.",
  },
  {
    title: ""
  },
  {
    title: <span classname="highlight">శ్రీకృష్ణుని కుటుంబం :</span>,
  },
  {
    title: "శ్రీకృష్ణుడికి జన్మనిచ్చిన తండ్రి వసుదేవుడు",
  },
  {
    title: "శ్రీకృష్ణుడికి జన్మనిచ్చిన తల్లి దేవకీ",
  },
  {
    title: "శ్రీకృష్ణుడిని పెంచిన తండ్రి నందుడు",
  },
  {
    title: "శ్రీకృష్ణుడిని పెంచిన తల్లి యశోద",
  },
  {
    title: "శ్రీకృష్ణుడి సోదరుడు బలరాముడు",
  },
  {
    title: "శ్రీకృష్ణుడి సోదరి సుభద్ర",
  },
  {
    title: "శ్రీకృష్ణుని జన్మ స్థలం మధుర",
  },
  {
    title: "శ్రీకృష్ణుడి భార్యలు : రుక్మిణీ, సత్యభామ, జాంబవతీ, కాళింది, మిత్రవింద, నగ్నజితి, భద్ర, లక్ష్మణ",
  },
  {
    title: "శ్రీ కృష్ణుడు జీవితంలో కేవలం నలుగురిని మాత్రమే హతమార్చినట్టు సమాచారం. వారు :",
  },
  {
    title: "ఛణురా - కుస్తీదార",
  },
  {
    title: "కంసుడు - మేనమామ",
  },
  {
    title: "శిశుపాలుడు మరియు దంతవక్ర - అత్త కొడుకులు",
  },
  {
    title: "హిందూ మతంలో ముక్కోటి దేవతలున్నారు వారిలో అత్యంత ప్రసిద్ధి గాంచిన దేవుడైన కృష్ణుని గురించి మనలో అనేక మందికి తెలుసు. అయినప్పటికీ, శ్రీకృష్ణుని జీవితం మర్మంతో కూడుకున్నది. ఎంత తెలుసుకున్నా ఇంకా మిగిలే ఉంటుంది. కొందరైతే కృష్ణుని గురించి తెలుసుకోవడం, విశ్వం గురించి తెలుసుకోవడం ఒకటే అని భావిస్తుంటారు.",
  },
  {
    title: "",
  },
  {
    title: <span classname="highlight">ఈ విశ్వమంతా శ్రీకృష్ణుని నోటనే ఉన్నది :</span>,
  },
  {
    title: "శిశువుగా శ్రీ కృష్ణుడు ఒక అల్లరి పిల్లవాడు. చిన్నతనంలో అతను తన ఆనందం కోసం చేయదగిన అన్ని అల్లరి పనులూ చేశాడు కానీ, తన ప్రతి అల్లరి పనిలోనూ స్వలాభాపేక్ష లేని ప్రయోజనాలను చూపేవాడు. తన అమాయకత్వంతో చేసిన చిలిపి పనులుగా తోచినప్పటికీ, వాటి వెనుక గల అంతరార్ధం, పరమాత్ముని లీలలను ప్రదర్శించేవిలా ఉండేవి. క్రమంగా తన తల్లికి, తన నోటిలోనే విశ్వాన్ని చూపించి అబ్భురపరచాడు శ్రీ కృష్ణ భగవానుడు.",
  },
  // {
  //   title: "",
  // },
  {
    title: "శ్రీ కృష్ణ భగవానుడు ఇంటి వెలుపల ఆడుతున్న సమయంలో అతని అన్న బలరాముడు తల్లి యశోద కడకు వచ్చి శ్రీ కృష్ణుడు మట్టి తింటున్నాడని ఫిర్యాదు చేశాడు. మొదట్లో యశోద నమ్మని కారణంగా అతని నోటిని తెరిచి పరీక్షింపవలసినదిగా బలరాముడు సూచించగా యశోద కోపంతో శ్రీ కృష్ణుని ఇంటిలోనికి తీసుకుని వెళ్లి, నోటిని పరీక్షింపదలచినది. క్రమంగా నోరు తెరిచిన శ్రీకృష్ణుని నోట మొత్తం విశ్వమే కనపడగా, ఆశ్చర్యానికి లోనైన యశోదా దేవి, దైవాంశ సంభూతునిగా మరియు దేవుని అవతారముగా గ్రహించింది. కానీ తాను దేవుని అవతారంగా భావించిన యశోద దేవి తల్లిగా ఇక మీదట ఉండలేదని గ్రహించిన శ్రీ కృష్ణుడు, తన దైవ శక్తితో యశోదా దేవి జ్ఞాపకాల నుండి ఈ సంఘటననే తొలగించివేశాడని చెప్పబడింది.",
  },
  {
    title: ""
  },
  {
    title: <span classname="highlight">శ్రీ కృష్ణ భగవానుడు, అతని భార్యలు మరియు నారద మునీంద్రులు :</span>,
  },
  {
    title: "శ్రీ కృష్ణునికి 16108 భార్యలు ఉన్నారని మనకు తెలుసు. అష్టభార్యలు అని పిలువబడే ఎనిమిది మంది రాణులు వారిలో బాగా ప్రసిద్ది చెందారు. రుక్మిణి కృష్ణునికి మొదటి రాణి. రుక్మిణి తండ్రి ఆమెకు బలవంతంగా వేరే రాజుకి ఇచ్చి వివాహం చేయాలని సంకల్పిస్తాడు. కానీ ఆమె కృష్ణుడిని ప్రేమించిన కారణాన ఆ వివాహం నుండి ఆమెను రక్షించి తనతో తీసుకుని వెళ్ళిపోతాడు శ్రీ కృష్ణుడు. అడ్డు వచ్చిన రుక్మిణి అన్న “రుక్మి” ని ఓడించి సగం శిరోముండనం గావించి చంపకుండా వదిలిపెట్టాడని కథనం. నారదముని ద్వారకలో కృష్ణుని సందర్శించడానికి వచ్చినప్పుడు, శ్రీ కృష్ణుని మహిమలను తెలుసుకునే క్రమంలో భాగంగా, తన భార్యలలో ఒకరిని బహుమతిగా ఇవ్వమని కృష్ణుని అడుగుతాడు. క్రమంగా శ్రీ కృష్ణుడు, తన భార్యలలో ఎవరు ఒంటరిగా కనిపించినా అతను వారిని తన వెంట తీసుకెళ్ళవచ్చునని షరతు విధించాడు. క్రమంగా శోధించిన నారద మునీంద్రుల వారికి ఏ భార్య కూడా ఒంటరిగా కనపడలేదు. అన్నిటా శ్రీ కృష్ణుడే కొలువుతీరి ఉన్నాడు. శ్రీకృష్ణుని లీలగా గ్రహించిన నారద మునీంద్రులు, తప్పును క్షమించమని కృష్ణుని వేడుకున్నాడు.",
  },
  {
    title: "",
  },
  {
    title: <span classname="highlight">గాంధారి శాపం :</span>,
  },
  {
    title: "మహా భారత యుద్ధం సమయంలో శ్రీ కృష్ణ భగవానుడు గాంధారిని ఓదార్చటానికి వెళ్ళినప్పుడు తన వంశం మొత్తాన్ని నాశనం చేస్తున్నట్లుగా కృష్ణుని నిందించి, నేటి నుండి ముప్పై ఆరు సంవత్సరాల తర్వాత యాదవ వంశం పూర్తిగా నశిస్తుంది అని శాపమిచ్చింది. అలా శ్రీకృష్ణుడు యుద్దాన్ని ఆపి తన బిడ్డల ప్రాణాలు కాపాడడంలో సహాయం చేస్తాడని భావించింది. కానీ అలా జరగలేదు. కౌరవ వంశమే తుడిచిపెట్టుకుని పోయింది. అయితే కృష్ణుడు ఆ శాపానికి సమాధానంగా తథాస్తు అని బదులిచ్చాడు. అనగా “ఈలోకం పూర్తిగా పాపాలతో నిండిపోయింది, కావున యుగాంతం జరుగక తప్పదు” అని శ్రీ కృష్ణుని ఉద్దేశం.",
  },
  {
    title: "",
  },
  {
    title: <span classname="highlight">శ్రీ కృష్ణ భగవానుడు మరియు శిశుపాలుడు :</span>,
  },
  {
    title: "శిశుపాలుడు ఒక సుప్రసిద్ధమైన మరియు చెడు లక్షణాలు కలిగిన రాజుగా పేరు పొందిన వానిగా ఉన్నాడు. శిశుపాలుని 100 తప్పుల వరకు అతనిని చంపను అని, శిశుపాలుని తల్లికి శ్రీ కృష్ణుడు మాట ఇచ్చిన కారణంగా అతనిని వందల తప్పుల వరకు క్షమించడం జరిగింది. కానీ ఒక సమావేశంలో శ్రీ కృష్ణుని పరిపరి విధాలుగా నిందించడం మొదలుపెట్టాడు శిశుపాలుడు. ప్రతి ఒక్క నిందను తప్పుగా లెక్కిస్తూ వచ్చిన శ్రీకృష్ణుడు, 100 తప్పులు పూర్తికాగానే తన సుదర్శనంతో శిశుపాలుని తలనరికి వధించాడు. శిశుపాలుడు, జరాసంధుడు నిజానికి పూర్వ జన్మలో జయ విజయులనే విష్ణుని ద్వారపాలకులు. శాపవశాత్తు మంచివాళ్ళుగా మూడువందల సంవత్సరాలు విష్ణువుకి దూరంగా ఉండలేని వీరు, కృతయుగంలో హిరణ్య కశిపుడు-హిరణ్యాక్షుడు, త్రేతాయుగంలో రావణ-కుంభకర్ణులు, మరియు ద్వాపర యుగంలో శిశుపాల-జరాసందులుగా అవతారమెత్తి త్వరగానే విష్ణుమూర్తి అవతారాల చేతులలోనే సంహరించబడి విష్ణువు వద్దకు చేరారని పురాణాల కథనం.",
  },
  {
    title: "",
  },
  {
    title: <span classname="highlight">శ్రీ కృష్ణుడు మరియు ద్రౌపది :</span>,
  },
  {
    title: "మహాభారతంలో అన్నాచెల్లెళ్ళ ప్రేమకు నిదర్శనంగా శ్రీ కృష్ణుడు – ద్రౌపదిలను అభివర్ణించబడినది. ద్రౌపది పార్వతీదేవి అంశగా శ్రీ కృష్ణుడు విష్ణుమూర్తి అంశగా చెప్పబడింది. ఇక్కడ విష్ణువు- పార్వతీ దేవీలను అన్నా చెల్లెళ్ళుగా పురాణాలలో చెప్పబడింది.",
  },
  {
    title: "",
  },
  {
    title: <span classname="highlight">ఏకలవ్యునికి శ్రీ కృష్ణుని దీవెనలు :</span>,
  },
  {
    title: "ద్రోణాచార్యునికి ఏకలవ్యుడు తన బొటనవేలిని అర్పించినప్పుడు, శ్రీకృష్ణుడు ఏకలవ్యునికి ఒక వరమిచ్చినట్లుగా ప్రతీతి. క్రమంగా యజ్ఞం నుండి పుట్టిన ద్రుష్టద్యుమ్నుడి చేత ద్రోణాచార్యుడు వధించబడ్డాడు. కానీ, మహాభారత యుద్ధంలో కర్ణుడు, ఏకలవ్యుని చెల్లెలిని పరిణయమాడిన కారణాన ఏకలవ్యుడు కౌరవసైన్యం వైపు ఉండవలసి వచ్చిందని కథనం.",
  },
  {
    title: ""
  },
  {
    title: <span classname="highlight">జైనమతంలో శ్రీ కృష్ణ భగవానుడు :</span>,
  },
  {
    title: "శ్రీ కృష్ణుని ప్రస్తావన జైన సాహిత్యంలో కూడా కనుగొనబడింది. వీటిలో శ్రీకృష్ణుని వాసుదేవునిగా, కథానాయకునిగా వర్ణించారు.",
  },
  {
    title: "",
  },
  {
    title: <span classname="highlight">బౌద్ధమతంలో శ్రీ కృష్ణ భగవానుడు :</span>,
  },
  {
    title: "బౌద్ధ సాహిత్యం ప్రకారం వైభవ జాతకంలో కంస వధ కోసం శ్రీ కృష్ణుడు యువరాజులా వచ్చాడని చెప్పబడింది.",
  },
  {
    title: <span classname="highlight">జగమంతా కృష్ణ మయం అన్నట్లు ఈ విశ్వమంతా కృష్ణుని చేతనే నడుపబడుతుందని భక్తుల విశ్వాసం.</span>,
  },
  {
    title: ""
  },
  {
    title: <span classname="highlight">శ్రీకృష్ణుడిని వివిధ ప్రాంతాలలో వివిధ నామాలతో పూజిస్తారు. అవి :</span>,
  },
  {
    title: "మధురలో కన్నయ్యగా",
  },
  {
    title: "ఒడిశాలో జగనాథుడ్నిగా",
  },
  {
    title: "మహారాష్ట్ర లో విఠల(విఠోబ)గా",
  },
  {
    title: "రాజస్తాన్ లో శ్రీనాథుడిగా",
  },
  {
    title: "గుజరాత్ లో ద్వారకాదీసుడు & రాంచ్చోడ్ గా",
  },
  {
    title: "ఉడిపి, కర్ణాటకలో శ్రీకృష్ణుడినిగా పూజలందుకుంటున్నాడు",
  },
];
export default unknownfacts;
